var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert_block"},[_c('CAlert',{attrs:{"color":"primary"}},[_vm._v(" This is info alert. ")]),_c('CAlert',{attrs:{"color":"warning","closeButton":""}},[_vm._v(" This is warning dismissible alert. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }